Service = App.loadClass 'core::Angular/Service'

class exports.TillageFilters extends Service
    constructor: (@service) ->
        undefined
